import { queryOptions } from '@tanstack/react-query';
import { client } from '#queries/utils';
import { registerBaseURL } from '#constants/hosts';
import { ApiGetOrganizationResponse } from '#proto/qonto/registration/organizations/firstparty/v1/get_organization';

export const registerOrganizationQueries = {
  all: ['register-organizations'] as const,
  lists: () => [...registerOrganizationQueries.all, 'list'] as const,
  items: () => [...registerOrganizationQueries.all, 'item'] as const,
  item: (id: string) =>
    queryOptions({
      queryKey: [...registerOrganizationQueries.items(), id] as const,
      queryFn: async () => {
        const json = await client(`${registerBaseURL}/v1/organizations/${id}`);

        return ApiGetOrganizationResponse.fromJSON(json);
      },
    }),
};
